export const JEWELRY_HIRE_LIST_REQUEST = "JEWELRY_HIRE_LIST_REQUEST";
export const JEWELRY_HIRE_LIST_SUCCESS = "JEWELRY_HIRE_LIST_SUCCESS";
export const JEWELRY_HIRE_LIST_FAIL = "JEWELRY_HIRE_LIST_FAIL";
export const JEWELRY_HIRE_LIST_RESET = "JEWELRY_HIRE_LIST_RESET";

export const JEWELRY_HIRE_DETAILS_REQUEST = "JEWELRY_HIRE_DETAILS_REQUEST";
export const JEWELRY_HIRE_DETAILS_SUCCESS = "JEWELRY_HIRE_DETAILS_SUCCESS";
export const JEWELRY_HIRE_DETAILS_FAIL = "JEWELRY_HIRE_DETAILS_FAIL";
export const JEWELRY_HIRE_DETAILS_RESET = "JEWELRY_HIRE_DETAILS_RESET";

export const ADMIN_JEWELRY_HIRE_LIST_REQUEST =
  "ADMIN_JEWELRY_HIRE_LIST_REQUEST";
export const ADMIN_JEWELRY_HIRE_LIST_SUCCESS =
  "ADMIN_JEWELRY_HIRE_LIST_SUCCESS";
export const ADMIN_JEWELRY_HIRE_LIST_FAIL = "ADMIN_JEWELRY_HIRE_LIST_FAIL";
export const ADMIN_JEWELRY_HIRE_LIST_RESET = "ADMIN_JEWELRY_HIRE_LIST_RESET";

export const ADMIN_JEWELRY_HIRE_DETAILS_REQUEST =
  "ADMIN_JEWELRY_HIRE_DETAILS_REQUEST";
export const ADMIN_JEWELRY_HIRE_DETAILS_SUCCESS =
  "ADMIN_JEWELRY_HIRE_DETAILS_SUCCESS";
export const ADMIN_JEWELRY_HIRE_DETAILS_FAIL =
  "ADMIN_JEWELRY_HIRE_DETAILS_FAIL";
export const ADMIN_JEWELRY_HIRE_DETAILS_RESET =
  "ADMIN_JEWELRY_HIRE_DETAILS_RESET";

export const ADMIN_JEWELRY_HIRE_CREATE_REQUEST =
  "ADMIN_JEWELRY_HIRE_CREATE_REQUEST";
export const ADMIN_JEWELRY_HIRE_CREATE_SUCCESS =
  "ADMIN_JEWELRY_HIRE_CREATE_SUCCESS";
export const ADMIN_JEWELRY_HIRE_CREATE_FAIL =
  "ADMIN_JEWELRY_HIRE_CREATE_FAIL";
export const ADMIN_JEWELRY_HIRE_CREATE_RESET =
  "ADMIN_JEWELRY_HIRE_CREATE_RESET";

export const ADMIN_JEWELRY_HIRE_UPDATE_REQUEST =
  "ADMIN_JEWELRY_HIRE_UPDATE_REQUEST";
export const ADMIN_JEWELRY_HIRE_UPDATE_SUCCESS =
  "ADMIN_JEWELRY_HIRE_UPDATE_SUCCESS";
export const ADMIN_JEWELRY_HIRE_UPDATE_FAIL =
  "ADMIN_JEWELRY_HIRE_UPDATE_FAIL";
export const ADMIN_JEWELRY_HIRE_UPDATE_RESET =
  "ADMIN_JEWELRY_HIRE_UPDATE_RESET";

export const ADMIN_JEWELRY_HIRE_DELETE_REQUEST =
  "ADMIN_JEWELRY_HIRE_DELETE_REQUEST";
export const ADMIN_JEWELRY_HIRE_DELETE_SUCCESS =
  "ADMIN_JEWELRY_HIRE_DELETE_SUCCESS";
export const ADMIN_JEWELRY_HIRE_DELETE_FAIL =
  "ADMIN_JEWELRY_HIRE_DELETE_FAIL";
export const ADMIN_JEWELRY_HIRE_DELETE_RESET =
  "ADMIN_JEWELRY_HIRE_DELETE_RESET";
